import { useState } from 'react';

import { useToast } from 'components/hooks/useToast';

import { IMAGE_UPLOAD_SUCCESS, TOAST_STATUSES, IMAGE_UPLOAD_ERROR } from 'constants/ProjectConstants';

import { uploadPostMedia } from 'services/post';

function getFileUrl(fileObject) {
  if (fileObject) return URL.createObjectURL(fileObject);
  return '';
}

const useUploadImage = ({ setImage }: { setImage: (image: any) => void }) => {
  const toast = useToast();
  const [isUploading, setIsUploading] = useState(false);
  const [imageUrl, setImageUrl] = useState('');

  const uploadFile = async (file) => {
    setIsUploading(true);
    try {
      // @ts-ignore
      const media = await uploadPostMedia({ attachment: file });
      setImage(media);
      toast({
        title: IMAGE_UPLOAD_SUCCESS,
        status: TOAST_STATUSES.SUCCESS,
        position: 'bottom-left',
      });
      const uploadedFileUrl = getFileUrl(file);
      setImageUrl(uploadedFileUrl);
    } catch (error) {
      console.error('Error uploading image : ', error);
      toast({
        title: IMAGE_UPLOAD_ERROR,
        status: TOAST_STATUSES.ERROR,
        position: 'bottom-left',
      });
    } finally {
      setIsUploading(false);
    }
  };

  return {
    imageUrl,
    isUploading,
    uploadFile,
  };
};

export default useUploadImage;
